angular
    .module('annexaApp')
    .component('annexaDossierHistory',{
        templateUrl: './components/tram/annexa-dossier-history/annexa-dossier-history.html',
        controller:['$scope', 'Language', 'TramNewFactory', 'TableFilterFactory', '$filter', 'AnnexaPermissionsFactory', '$state', 'GlobalDataFactory', '$rootScope', 'RouteStateFactory', 'HelperService', function ($scope, Language, TramNewFactory, TableFilterFactory, $filter, AnnexaPermissionsFactory, $state, GlobalDataFactory, $rootScope, RouteStateFactory, HelperService) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            var routeState = RouteStateFactory.getRouteState($state.current);
            var getFilterCall = function() {
            	return {dossier: {id : vm.dossierId}};
            }

            var getFilterCallAux = function () {
            	var additionalFilter = {
            			loggedUser : $rootScope.LoggedUser.id,
                    	filterOrigin: 'tram',
                    	history: true
            	};
            	return additionalFilter;
            }
            var TramStatusColumnRender = function (data, type, full, meta) {
                var content = '';
                content += '<span class="text-nowrap">';
                if(data == null || new Date() < new Date(data)) {
                    content += '<i class="m-l-xs fa fa-unlock text-warn" title="{{ \'global.tram.literals.open_transaction\' | translate }}"></i>';
                } else {
                    content += '<i class="m-l-xs fa fa-lock text-success" title="{{ \'global.tram.literals.ended_transaction\' | translate }}"></i>';
                }
                content += '</span>';
                return content;
            }
            
            var DocumentsCounterColumnRender = function (data, type, full, meta) {
            	return '<span class="text-nowrap">' + ((data) ? data : 0) + '</span>';
            }
            
            var TransactionHistoryColumnRender = function(data, type, full, meta) {
            	var content = '';
            	
            	if(full && full.id && full.dossier && full.dossier.id && AnnexaPermissionsFactory.havePermission(['process_dossier'])){
            		content = "<a ui-sref='annexa.tram.pending.viewdossier({dossier: " + full.dossier.id + ", dossierTransaction:" +full.id + ", selectedTab: \"center\"})' title='" + data + "' class='_600 text-primary'>" + data + "</a>";
            	}else if(full && full.dossier && full.dossier.id && AnnexaPermissionsFactory.havePermission(['process_dossier'])){
            		content = "<a ui-sref='annexa.tram.pending.viewdossier({dossier: " + full.dossier.id + ", dossierTransaction: -1, selectedTab: \"center\"})' title='" + data + "' class='_600 text-primary'>" + data + "</a>";
            	}else if(full && full.dossier && full.dossier.id){
            		content = "<a ui-sref='annexa.tram.view.viewdossier({dossier: " + full.dossier.id + "})' title='" + data + "' class='_600 text-primary' target='_blank'>" + data + "</a>";
            	}else{
            		content = data;
            	}
            	
            	return content;
                
            }

            this.$onInit = function () {
				vm.legend = [
					{icon:'unlock', style: 'text-warn', name:'global.tram.literals.open_transaction'},
					{icon:'lock', style: 'text-success', name:'global.tram.literals.ended_transaction'}
				];

                vm.tableDefinition = {
                    id: 'tableTramHistory',
                    origin: 'tram',
                    objectType: 'DossierTransaction',
                    objectIdToSelectOrigin: 'tram',
    				objectIdToSelectType: 'Dossier',
                    sortName: 'createdDate',
                    sort: [[3, 'asc']],
                    filterCall: getFilterCall(),
                    filterCallAux: getFilterCallAux(),
                    filterCallFunc: getFilterCall,
                    filterCallAuxFunc: getFilterCallAux,
                    columns: [
                        { id: 'endDate', width: '40px', title: $filter('translate')('global.literals.state'), render: TramStatusColumnRender },
                        { id: 'transactionType.' + Language.getActiveColumn(),width: '200px', title: $filter('translate')('global.tram.literals.transaction_type') },
                        { id: Language.getActiveColumn(),width: '250px', title: $filter('translate')('global.literals.transaction'), render: TransactionHistoryColumnRender},
                        { id: 'createdDate', width: '150px', column: new DateTimeColumn($filter, 'global.literals.creation_date') },
                        { id: 'countDossierTransactionDocuments', width: '80px', title: $filter('translate')('global.tram.literals.documents_count'), render: DocumentsCounterColumnRender, sortable: false },
                        { id: 'comment',width: '400px', column: new StrippedEllipsableColumn($filter, 'global.literals.observations', 175, true)}
                    ],
                    containerScope: $scope,
                    useTableObjects: true,
                    multipleActions: false,
                    callOrigin: 'historyTable'
                };
            }
        }],
        bindings: {
            dossierId: '='
        }
    });